import React from 'react';
import MaterialIcon from './MaterialIcon';

const renderIcon = (Icon, color) => {
    if (!Icon) return null;
    if (typeof Icon === 'string') return <MaterialIcon name={Icon} size={22} className={color} />;
    return <Icon className={`w-5 h-5 ${color}`} />;
};

const SectionHeader = ({ icon: Icon, title, color = 'text-forest-700', accent = 'bg-forest-100' }) => (
    <div className="flex items-center gap-3 mb-5">
        <div className={`w-11 h-11 rounded-2xl flex items-center justify-center ${accent}`}>
            {renderIcon(Icon, color)}
        </div>
        <h3 className="text-lg font-bold text-primary-dark">{title}</h3>
    </div>
);

export default SectionHeader;
